function changeTextNPersonas() {
    var adultsTxt = "";
    var childsTxt = "";
    var habsTxt = "";
    var adults = 0;
    var childs = 0;
    var habs = 0;

    habs = $('#habs').val();

    //Obtenemos el numero de personas y habitaciones
    for (var i = 1; i <= habs; i++) {
       adults = adults + parseInt($('#adu'+i).val());
       childs = childs + parseInt($('#nen'+i).val());
    }

    //Buscamos si la palabra será plural o singular
    if (adults > 1) {
        adultsTxt = translations.adults;
    }else {
        adultsTxt = translations.adult;
    }

    if (childs > 1) {
        childsTxt = translations.childs;
    }else {
        childsTxt = translations.child;
    }

    if (habs > 1) {
        habsTxt = translations.rooms;
    }else {
        habsTxt = translations.room;
    }

    peopleTxt = translations.people;
    //Colocamos el texto
    if (childs <= 0) {
        $('input[data-name="nPeopleText"]').attr('placeholder', adults+' '+adultsTxt+' en '+habs+' '+habsTxt);
        $('input[data-name="nPeopleText"]').val(adults+' '+adultsTxt+' en '+habs+' '+habsTxt);
        if ($("#slopes-search-people")[0]) {
            $("#slopes-search-people").text(adults + ' ' + peopleTxt);
        }

    } else {
        $('input[data-name="nPeopleText"]').attr('placeholder', adults+' '+adultsTxt+', '+childs+' '+childsTxt+' en '+habs+' '+habsTxt);
        $('input[data-name="nPeopleText"]').val(adults+' '+adultsTxt+', '+childs+' '+childsTxt+' en '+habs+' '+habsTxt);
        if ($("#slopes-search-people")[0]) {
            people = adults + childs;
            $("#slopes-search-people").text(people + ' ' + peopleTxt);
        }
    }
}

//Monto la frase para el input ¿Dónde quieres ir?
window.txt_donde_ir = function(zona, area, domini, moda, opt){

    var destino = "";

    if(domini != ""){
        if(zona == 3){
            if(area != ""){

                $('li[data-area=' + area + ']').each(function( index ) {

                    if($(this).data('name') == 'domini' && $(this).data('moda') == moda && $(this).data('zona') == zona && $(this).data('opt') == opt && $(this).data('value') == ''){
                        destino = $(this).text();
                    }
                });
            }

        }else{

            $('li[data-value=' + domini + ']').each(function( index ) {

                if($(this).data('name') == 'domini' && $(this).data('moda') == moda && $(this).data('zona') == zona && $(this).data('area') == area && $(this).data('opt') == opt){
                    destino = $(this).text();
                }
            });
        }

    }else if(area != ""){

        $('li[data-area=' + area + ']').each(function( index ) {

            if($(this).data('name') == 'domini' && $(this).data('moda') == moda && $(this).data('zona') == zona && $(this).data('opt') == opt && $(this).data('value') == ''){
                destino = $(this).text();
            }
        });

    }else if(zona != ""){

        $('li[data-zona=' + zona + ']').each(function( index ) {

            if($(this).data('name') == 'domini' && $(this).data('moda') == moda && $(this).data('opt') == opt && $(this).data('area') == '' && $(this).data('value') == ''){
                destino = $(this).text();
            }
        });
    }

    if(destino != ""){

        if ($(".searcher-location")[0]) {
            $(".searcher-location").text(destino);
        }
    }

    return destino;

}

$(document).ready(function() {

    if($(".cl-booking").length > 0){

        var wTxtDondeIr = txt_donde_ir($("input[name='zona']").val(),$("input[name='area']").val(),$("input[name='domini']").val(),$("input[name='moda']").val(), $("input[name='opt_radio_search']").val());

        if(wTxtDondeIr != ''){
            $("#btn-dominitxt").val(wTxtDondeIr);
            $("#id-search-summary #id-destination-name").text(wTxtDondeIr);
        }
    }

    //Elegir dominio de la lista
    $('li[data-name="domini"]').click(function () {

        var domini = $(this).attr('data-value');
        $('input[name="domini"]').val(domini).trigger('change');
        $('#dataDominiohotelA').val(domini);
        $('input[data-name="dominitxt"]').val($(this).text());
        var moda = $(this).attr('data-moda');
        $('input[name="moda"]').val(moda);
        $('#dataModa').val(moda);
        var everano = $(this).attr('data-everano');
        $('input[name="esquiverano"]').val(everano);
        var tematica = $(this).attr('data-tematica');
        $('input[name="tematica"]').val(tematica);
        var opt = $(this).attr('data-opt');
        $('input[name="opt_radio_search"]').val(opt);
        $('#dataOpt').val(opt);
        var zona = $(this).attr('data-zona');
        $('input[name="zona"]').val(zona).trigger('change');
        $('#dataZonahotelA').val(zona);
        var area = $(this).attr('data-area');
        $('input[name="area"]').val(area).trigger('change');
        $('#dataAreahotelA').val(area);

        if ($(".slopes-search-top-row")[0]) {
            $(".slopes-search-top-row").text( $(this).text() );
        }

        if($(".cl-booking").length > 0){

            if(moda == 'E' || moda == 'B'){
                $('#id-ctn-skipassDates').show();
            }else{
                $('#id-ctn-skipassDates').hide();
            }
        }
    });

    $('button[name="increaseButton"]').click(function () {

        //Busca el input asociado dentro del mismo elemento
        var mainInput = $(this).parent().children("input");

        //Le damos valor al input si el value está vacio
        var value = (mainInput.val() != '')? parseInt(mainInput.val()) : 0;

        //Coje el holder para saber si esta activado o no
        var holderActive = $(this).parent().parent().parent();

        //Incrementa si es menor que el maximo y si esta activo
        if (value < parseInt(mainInput.attr("max")) && !holderActive.hasClass("lg-opacity")) {

            if(mainInput.val() != ''){
                mainInput.val(value + 1);
            }else{
                mainInput.val(0);
            }
        }

        //Controla la opacidad de las habitaciones
        //Si el holder no esta activo deshabilitamos los inputs para que no se envien
        if (mainInput.attr("id") == "habs") {
            if (parseInt(mainInput.val()) == 2) {
                $('div[data-name="holderHab2"]').removeClass('lg-opacity');
                $('div[data-name="globalHolderNen2"]').removeClass('lg-opacity');
                $('div[data-name="holderHab2"]').find( "input" ).prop('disabled', false);
                $('div[data-name="globalHolderNen2"]').find( "input" ).prop('disabled', false);
            }
            if (parseInt(mainInput.val()) == 3) {
                $('div[data-name="holderHab3"]').removeClass('lg-opacity');
                $('div[data-name="globalHolderNen3"]').removeClass('lg-opacity');
                $('div[data-name="holderHab3"]').find( "input" ).prop('disabled', false);
                $('div[data-name="globalHolderNen3"]').find( "input" ).prop('disabled', false);
            }
        }

        //Muestra los niños segun su value
        for (var i = 1; i < 5; i++) {
            if (mainInput.attr("id") == "nen"+i) {
                for (var j = 1; j < 5; j++) {
                    if (parseInt(mainInput.val()) == j) {
                        $('div[data-name="holderNen'+i+''+j+'"]').removeClass('d-none');
                        $('div[data-name="globalHolderNen'+i+'"]').removeClass('d-none');
                    }
                }
            }
        }
        changeTextNPersonas();
    });

    $('button[name="decreaseButton"]').click(function () {

        var error = 0;

        //Busca el input asociado dentro del mismo elemento
        var mainInput = $(this).parent().children("input");

        //Coje el holder para saber si esta activado o no
        var holderActive = $(this).parent().parent().parent();

        //Que no puedas dejar a 0 los adultos de la hab2 y hab3 si no hay niños seleccionados
        if(((mainInput.attr("id") == "adu2" && $('#nen2').val() == 0) || (mainInput.attr("id") == "adu3" && $('#nen3').val() == 0)) && (mainInput.val() == 1)){
            error = 1;
        }

        //Que no puedas dejar a 0 los niños de la hab2 y hab3 si no hay adultos seleccionados
        if(((mainInput.attr("id") == "nen2" && $('#adu2').val() == 0) || (mainInput.attr("id") == "nen3" && $('#adu3').val() == 0)) && (mainInput.val() == 1)){
            error = 1;
        }

        //Decrementa si es mayor que el minimo
        if (parseInt(mainInput.val()) > parseInt(mainInput.attr("min")) && !holderActive.hasClass("lg-opacity") && error == 0) {
            mainInput.val(parseInt(mainInput.val()) - 1);
        }

        //Controla la opacidad de las habitaciones
        //Si el holder no esta activo deshabilitamos los inputs para que no se envien
        if (mainInput.attr("id") == "habs") {
            if (parseInt(mainInput.val()) == 1) {
                $('div[data-name="holderHab2"]').addClass('lg-opacity');
                $('div[data-name="globalHolderNen2"]').addClass('lg-opacity');
                $('div[data-name="holderHab2"]').find( "input" ).prop('disabled', true);
                $('div[data-name="globalHolderNen2"]').find( "input" ).prop('disabled', true);
            }
            if (parseInt(mainInput.val()) == 2) {
                $('div[data-name="holderHab3"]').addClass('lg-opacity');
                $('div[data-name="globalHolderNen3"]').addClass('lg-opacity');
                $('div[data-name="holderHab3"]').find( "input" ).prop('disabled', true);
                $('div[data-name="globalHolderNen3"]').find( "input" ).prop('disabled', true);
            }
        }

        //Oculta los niños segun su value
        for (var i = 1; i < 5; i++) {
            if (mainInput.attr("id") == "nen"+i) {
                for (var j = 1; j < 5; j++) {
                    if (parseInt(mainInput.val()) == j-1) {
                        $('div[data-name="holderNen'+i+''+j+'"]').addClass('d-none');

                        if (parseInt(mainInput.val()) == 0) {
                            $('div[data-name="globalHolderNen'+i+'"]').addClass('d-none');
                        }
                    }
                }
            }
        }
        changeTextNPersonas();
    });

    //PeopleNumber
    //Cerramos el modal de personas de manera especial ya que si no cierra todos.
    $("button[data-dismiss=modalPeople]").click(function(){

        var error=0;

        for (var i = 1; i <= 3; i++) {

            if(!$('div[data-name="holderHab'+i+'"]').hasClass('lg-opacity')){

                for (var j = 1; j <= 4; j++) {

                    if(!$('div[data-name="holderNen'+i+''+j+'"]').hasClass('d-none') && $('#edat'+i+j).val() == ''){
                        error = 1;
                        error_txt = translations.emptyAge;
                    }
                }
            }
        }

        if(error==0){
            $("#id-errorAge").hide();
            $('#nPpeople').modal('hide');
        }else{
            $("#id-errorAge").show();
        }
    });

    $('#btn_submit_searcher').click(function () {

        var error = 0;
        var error_txt = "";
        var dominiotxt = $('#btn-dominitxt').val();
        var tipoP = $('input[name="tipoP"]').val();
        var fecha_inicio = $('input[name="datapicker"]').val();
        var fecha_final = $('input[name="datapickerOut"]').val();

        if(dominiotxt == ''){
            error = 1;
            error_txt = translations.emptyDestination;
        }

        if(fecha_inicio == fecha_final){
            if(tipoP == ''){
                error = 1;
                error_txt = translations.emptyDate;
            }
        }

        for (var i = 1; i <= 3; i++) {

            if(!$('div[data-name="holderHab'+i+'"]').hasClass('lg-opacity')){

                for (var j = 1; j <= 4; j++) {

                    if(!$('div[data-name="holderNen'+i+''+j+'"]').hasClass('d-none') && $('#edat'+i+j).val() == ''){
                        error = 1;
                        error_txt = translations.emptyAge;
                    }
                }
            }
        }

        if(error == 1){

            $('#currentMessage').html(error_txt);
            $('#emptyErrorModal').modal('show');
            return false;

        }

    });

});

//Reiniciamos los valores del modal de personas al recargar la página
// $(document).ready(function() {
//     // $('#habs').val(1);

//     // for (var i = 1; i < 4; i++) {
//     //     $('#adu'+i).val(0);
//     //     $('#nen'+i).val(0);
//     // }

//     // $('#adu1').val(2);

//     // for (var i = 1; i < 5; i++) {
//     //     for (var j = 1; j < 5; j++) {
//     //         $('input[name="edat'+i+''+j+'"]').val(0);
//     //     }
//     // }
// });
